import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hbOrderBy', pure: false })
export class OrderByPipe implements PipeTransform {
  static orderByComparator(a: any, b: any): number {
    // if (Object.keys(a).length > 0 || Object.keys(b).length > 0) {
    //   return 0;
    // }

    if (a === undefined) {
      a = 0;
    }
    if (b === undefined) {
      b = 0;
    }

    if (
      isNaN(parseFloat(a)) ||
      !isFinite(a) ||
      isNaN(parseFloat(b)) ||
      !isFinite(b)
    ) {
      // Isn't a number so lowercase the string to properly compare
      if (
        typeof a.toLowerCase === 'function' &&
        typeof b.toLowerCase === 'function'
      ) {
        if (a.toLowerCase() < b.toLowerCase()) {
          return -1;
        }
        if (a.toLowerCase() > b.toLowerCase()) {
          return 1;
        }
      }
    } else {
      // Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) {
        return -1;
      }
      if (parseFloat(a) > parseFloat(b)) {
        return 1;
      }
    }

    return 0; // equal each other
  }

  static getPropertyValue(prop: string, obj: any): any {
    // let tokens: string[] = prop.split('.');
    // let tok: any;
    // let open: any;
    // let close: any;
    // let ind: any;

    // for (let tok of tokens) {
    //   close = tok.indexOf(']');
    //   if (close > 0) {
    //     open = tok.indexOf('[');
    //     ind = tok.substr(open + 1, close - open - 1);
    //     obj = obj[tok.substr(0, open)][ind];
    //   } else {
    //     if (obj[tok] !== undefined) {
    //       obj = obj[tok];
    //     }
    //   }
    // }
    // return obj;
    return prop.split('.').reduce((memo: any, part: any) => {
      return memo[part];
    }, obj);
  }

  transform(input: any[], config: string = '+'): any {
    // make a copy of the input's reference

    if (
      !Array.isArray(config) ||
      (Array.isArray(config) && config.length === 1)
    ) {
      const propertyToCheck: string = !Array.isArray(config)
        ? config
        : config[0];
      const desc = propertyToCheck.substr(0, 1) === '-';

      // Basic array
      if (
        !propertyToCheck ||
        propertyToCheck === '-' ||
        propertyToCheck === '+'
      ) {
        return !desc ? [...input].sort() : [...input].sort().reverse();
      } else {
        const property: string =
          propertyToCheck.substr(0, 1) === '+' ||
          propertyToCheck.substr(0, 1) === '-'
            ? propertyToCheck.substr(1)
            : propertyToCheck;

        return [...input].sort((a: any, b: any) => {
          const valueA: any = OrderByPipe.getPropertyValue(property, a);
          const valueB: any = OrderByPipe.getPropertyValue(property, b);
          // console.log('a[property]', property, valueA);
          // console.log('b[property]', property, valueB);
          return !desc
            ? OrderByPipe.orderByComparator(valueA, valueB)
            : -OrderByPipe.orderByComparator(valueA, valueB);
        });
      }
    } else {
      // Loop over property of the array in order and sort
      return [...input].sort((a: any, b: any) => {
        for (const item of config) {
          const desc = item.substr(0, 1) === '-';
          const property =
            item.substr(0, 1) === '+' || item.substr(0, 1) === '-'
              ? item.substr(1)
              : item;

          const valueA: any = OrderByPipe.getPropertyValue(property, a);
          const valueB: any = OrderByPipe.getPropertyValue(property, b);

          const comparison: any = !desc
            ? OrderByPipe.orderByComparator(valueA, valueB)
            : -OrderByPipe.orderByComparator(valueA, valueB);

          // Don't return 0 yet in case of needing to sort by next property
          if (comparison !== 0) {
            return comparison;
          }
        }

        return 0; // equal each other
      });
    }
  }
}
